.dealersidebar {
  position: relative;
  width: 455px;
  height: 100%;

  .tabs {
    display: flex;
    flex: 1;
  }

  .resizeHandle {
    position: absolute;
    top: 0;
    right: 0;
    width: 6px;
    height: 100%;
    cursor: col-resize;
    background-color: transparent;
    z-index: 10;
    transition: background-color 0.2s ease;
    border-right: 1px solid var(--sparky-grey-200);

    &:hover {
      background-color: var(--sparky-grey-400);
      border-right-color: var(--sparky-grey-400);
    }

    &:active {
      background-color: var(--sparky-blue-300);
      border-right-color: var(--sparky-blue-300);
    }
  }

  .keyDealerContainer {
    padding: 0 32px 16px;
    border-bottom: 1px solid var(--sparky-grey-200);
  }

  .accordionContainer {
    padding: 4px 32px 8px;
    border-bottom: 1px solid var(--sparky-grey-200);
  }

  .tabContentContainer {
    display: flex;
    flex-direction: column;

    .keyDealerTitle {
      display: flex;
      margin: 0 0 8px 0;
    }

    .dealerSelect {
      display: flex;
      flex-direction: column;
      row-gap: 6px;

      > span {
        padding-left: 4px;
      }
    }

    .dealerFilter {
      width: 100%;
      margin: 0 0 8px;
    }

    .dealerList {
      display: flex;
      flex-direction: column;
      max-height: 350px;
      overflow-y: auto;
      padding-right: 8px;
    }
  }
}

.spacer {
  height: 24px;
}

.accordian {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  row-gap: 8px;
  border-top: 1px solid var(--sparky-grey-200);

  .accordianHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0 8px;

    .accordianTitle {
      display: flex;
      align-items: center;
    }

    .accordianControl {
      cursor: pointer;
      transform: rotate(90deg);

      &.closed {
        transform: rotate(270deg);
      }
    }
  }
}

.option {
  padding: 8px;
  column-gap: 8px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: var(--sparky-grey-100);
    cursor: pointer;
  }
}

.optionsWarning {
  margin: 8px;
}
